<template>
    <rkm-area
        background-color="success"
        closed
        header-prefix-icon="check-circle"
        title="Alta"
        type="box"
    >
        <template>
            <rkm-row>
                <rkm-col cols="3">
                    <Item
                        :get-value="() => item.dataAlta"
                        label="Data da alta"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <Item
                        :get-value="() => item.horaAlta"
                        label="Hora da alta"
                    />
                </rkm-col>
                <rkm-col cols="6">
                    <Item
                        :get-value="() => item.codTipoAlta"
                        label="Tipo de alta"
                    />
                </rkm-col>
            </rkm-row>
        </template>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        Item,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>